(() => {
  const KEY = 'astora-wishlist-v1';
  const PAGE = '/collections/all?view=wishlist';
  const HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-8-4.9-8-11A4.5 4.5 0 0 1 12 6.6a4.5 4.5 0 0 1 8 2.9c0 6.1-8 11-8 11z"/></svg>';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  const write = (items) => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); return true; } catch (e) { return false; }
  };

  function moveProductHeart() {
    const heart = document.querySelector('[data-astora-pdp-heart]');
    const gallery = document.querySelector('main media-gallery');
    if (heart && gallery && heart.parentElement !== gallery) gallery.appendChild(heart);
    if (heart) heart.hidden = false;
  }

  function headerLink(count) {
    let link = document.querySelector('.astora-header-saved');
    if (!count) { link?.remove(); return; }
    const actions = document.querySelector('header-actions');
    if (!actions) return;
    if (!link) {
      link = document.createElement('a');
      link.className = 'astora-header-saved';
      link.href = PAGE;
      link.innerHTML = HEART;
      link.setAttribute('aria-label', 'Saved fragrances');
      actions.prepend(link);
    }
  }

  function sync() {
    const saved = read();
    document.querySelectorAll('[data-astora-wishlist]').forEach((button) => {
      const pressed = String(saved.includes(button.dataset.astoraWishlist));
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      const label = (pressed === 'true' ? 'Remove from saved: ' : 'Save: ') + (button.dataset.title || 'fragrance');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    headerLink(saved.length);
    moveProductHeart();
  }

  let toastTimer;
  function toast(saved, stored) {
    document.querySelector('.astora-toast')?.remove();
    const box = document.createElement('div');
    box.className = 'astora-toast';
    box.setAttribute('role', 'status');
    if (!stored) {
      box.textContent = 'We could not save this in your browser.';
    } else if (saved) {
      box.textContent = 'Saved on this device.';
      const link = document.createElement('a');
      link.href = PAGE;
      link.textContent = 'View saved';
      box.appendChild(link);
    } else {
      box.textContent = 'Removed from saved.';
    }
    document.body.appendChild(box);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => box.remove(), 3500);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-astora-wishlist]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = button.dataset.astoraWishlist;
    const items = read();
    const saved = !items.includes(handle);
    const stored = write(saved ? [...items, handle] : items.filter((item) => item !== handle));
    sync();
    toast(saved, stored);
    renderSavedPage();
  }, true);

  function money(pence) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);
  }

  function savedCard(product) {
    const item = document.createElement('li');
    item.className = 'astora-saved__item';
    const media = document.createElement('div');
    media.className = 'card-gallery';
    const link = document.createElement('a');
    link.href = product.url;
    const image = document.createElement('img');
    if (product.featured_image) image.src = product.featured_image;
    image.alt = product.title;
    image.loading = 'lazy';
    image.style.cssText = 'display:block;width:100%;aspect-ratio:1;';
    link.appendChild(image);
    const heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'astora-heart';
    heart.dataset.astoraWishlist = product.handle;
    heart.dataset.title = product.title;
    heart.innerHTML = HEART;
    media.append(link, heart);
    const vendor = document.createElement('p');
    vendor.className = 'astora-card-vendor';
    vendor.textContent = product.vendor;
    const title = document.createElement('h2');
    title.className = 'astora-card-title';
    const titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    titleLink.style.cssText = 'color:inherit;text-decoration:none;';
    title.appendChild(titleLink);
    const price = document.createElement('p');
    price.textContent = product.available ? money(product.price) : 'Sold out';
    price.style.margin = '0';
    item.append(media, vendor, title, price);
    return item;
  }

  async function renderSavedPage() {
    const root = document.querySelector('[data-astora-saved]');
    if (!root) return;
    const handles = read();
    const list = root.querySelector('[data-astora-saved-list]');
    const empty = root.querySelector('[data-astora-saved-empty]');
    const results = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        return response.ok ? await response.json() : null;
      } catch (e) { return null; }
    }));
    const products = results.filter(Boolean);
    list.replaceChildren(...products.map(savedCard));
    empty.hidden = products.length > 0;
    sync();
  }

  function hideEmptyAccordions() {
    document.querySelectorAll("main[data-template^='product'] accordion-custom").forEach((row) => {
      const details = row.querySelector('details');
      if (!details) return;
      const text = [...details.children].filter((child) => child.tagName !== 'SUMMARY').map((child) => child.textContent).join('').trim();
      if (!text) row.hidden = true;
    });
  }

  let queued = false;
  function start() {
    sync();
    hideEmptyAccordions();
    renderSavedPage();
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
